__webpack_require__.p = "/People-Review-Slider/";